import { BaseOpportunityTask } from "./shared"

type TaskMilestone = {
  name: string
  id: string
}

export const TASK_STATUS = [
  "Completed",
  "Not Started",
  "In Progress",
  "Waiting on someone else",
  "Deferred",
  "Unresponsive",
  "Disqualified",
  "Cancelled",
] as const

export const TASK_PRIORITY = ["Normal", "High", "Low"] as const

export const TASK_TYPE = ["Other", "Call", "Meeting", "Email", "Live Chat", "AWSMP - SA"] as const

export const BD_ACTIVITY = [
  "PTR - External Technical Content",
  "PTR - Internal Technical Content",
  "PTR - Partner Programs Technical Validations",
  "PTR - Public Speaking",
  "PTR - Service Beta",
  "PTR - Strategic Enablement",
  "PTR - Technical Validations",
  "PTR - Miscellaneous",
]

export const SA_ACTIVITY = [
  "Architecture Review [Architecture]",
  "Demo [Architecture]",
  "Prototype/PoC/Pilot [Architecture]",
  "Cloud Adoption Framework [Architecture]",
  "Migration Readiness Assessment [Architecture]",
  "Well Architected [Architecture]",
  "MAP (Migration Acceleration Program) [Program Execution]",
  "Cost Optimization [Management]",
  "RFI and RFP response [Management]",
  "Support and Enablement of Partners [Management]",
  "Partner Competency Assessment [Architecture]",
  "Foundational Technical Review [Architecture]",
  "General Tech Content [Thought Leadership]",
  "Other Thought Leadership [Thought Leadership]",
  "PR-FAQ [Thought Leadership]",
  "Public Speaking Conference [Thought Leadership]",
  "Other Workshops [Workshops]",
  "Immersion Day [Workshops]",
  "GameDay [Workshops]",
  "Hackathon [Workshops]",
]

export type Task = BaseOpportunityTask & {
  subject: string
  status: typeof TASK_STATUS[number]
  priority: typeof TASK_PRIORITY[number]
  accountName: string
  activityDate: string
  createdDate: string
  timeSpentHrs: string
  lastModifiedDate: string
  description: string
  bdActivityType: string
  opportunityName: string
  opportunityWorkstreamId?: string
  relatedId?: string
  relatedType: string
  relatedName?: string
  milestone: TaskMilestone
  type: string
  saActivity?: string
}

const TASK_CLOSED_ARRAY: Task["status"][] = ["Completed", "Disqualified", "Unresponsive"]

export const TASK_CLOSED_NAMES = new Set(TASK_CLOSED_ARRAY)
